import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the tab and its detail routes a "Size sets" crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/org/catalog-setup/size-sets')({
  staticData: { crumb: 'dictionary:setup.tabs.sizeSets' },
  component: Outlet,
});
